"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Format = exports.ZeroTypeEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const merge_1 = require("merge");
const config_1 = require("../../utils/config");
const localize_1 = require("../../utils/localize");
const SaudiRiyal_1 = require("../../assets/icons/SaudiRiyal");
const Price_style_1 = require("./Price.style");
const Typography_1 = require("../Typography");
var ZeroTypeEnum;
(function (ZeroTypeEnum) {
    ZeroTypeEnum["Zero"] = "zero";
    ZeroTypeEnum["Free"] = "free";
    ZeroTypeEnum["Null"] = "null";
})(ZeroTypeEnum || (exports.ZeroTypeEnum = ZeroTypeEnum = {}));
const Symbol = (val, option) => {
    return ((0, jsx_runtime_1.jsx)(Typography_1.default, { component: "span", typo: option === null || option === void 0 ? void 0 : option.typo, children: (option === null || option === void 0 ? void 0 : option.replace) && val === 'SAR' ? (0, jsx_runtime_1.jsx)(SaudiRiyal_1.default, {}) : val }));
};
const Format = ({ value, typo, sx, zeroPriceType, format, bold, strikeThrough, currencyUnitTypo, leading, trailing, isTipLabelType, currencyFormat, }) => {
    const { container, boldPrice } = (0, Price_style_1.default)(strikeThrough);
    const { cc = '', cs = '' } = currencyFormat;
    const node = (0, react_1.useMemo)(() => {
        if (!isTipLabelType && !value) {
            return null;
        }
        if (value === '0' && zeroPriceType === ZeroTypeEnum.Null) {
            return '';
        }
        if (value === '0' && zeroPriceType === ZeroTypeEnum.Free) {
            return 'Free';
        }
        const newValue = (0, localize_1.formatCurrencyValue)(value, currencyFormat) || '';
        const f = format || '{csf}{0}';
        const elem = (0, config_1.processFormat)(f, {
            '0': newValue,
            cc,
            cs,
            csf: Symbol(cs, { typo: currencyUnitTypo, replace: true }),
            ccf: Symbol(cc, { typo: currencyUnitTypo }),
        });
        return elem || newValue || '';
    }, [value, format, currencyFormat]);
    return ((0, jsx_runtime_1.jsxs)(Typography_1.default, { sx: (0, merge_1.merge)(true, container, bold && boldPrice, sx), component: "span", typo: typo, children: [leading, node, trailing] }));
};
exports.Format = Format;
exports.default = exports.Format;
